<template>
    <div>
        <ul class="advanced-list">
            <!-- <router-link to="/accounting-software">
                <li> <i class="mdi mdi-chevron-right mdi-24x"></i> Accounting Software</li>
            </router-link> -->
            <div v-for="(item,index) in items" @click="openItem(item,items)" :key="index">
                <li> 
                    <!-- <transition mode="out-in" name="icons"> -->
                    <i :class="{'mdi':true, 'mdi-chevron-right':true, 
                    'mdi-20x':true, 'open-accord':item.isopen}"></i> 
                    <!-- </transition> -->
                    <!-- <transition mode="out-in" name="icons">
                        <i v-show="item.isopen" class="mdi mdi-chevron-down mdi-24x"></i>
                    </transition> -->
                    {{item.title}}
                </li>
                <transition mode="out-in" name="accord">
                    <ul v-show="item.isopen" class="item">
                        <li  v-for="(content,index) in item.content" :key="index"
                        style="list-style:square"
                        class="content">  
                            <div style="width:20px; display:flex; align-items:center">
                                <div style="height:6px; width:6px; background:#fff"></div> &nbsp;
                            </div>
                            <div style="width:95%">
                                {{content}}
                            </div>
                        </li>
                        &nbsp;
                        <div class="has-text-primary">
                            <router-link tag="a" :to="item.link" class="has-text-primary">
                                <span class="productLink">Contact us for more details</span>
                                 <i class="mdi mdi-chevron-double-right"></i>
                            </router-link>
                        </div>
                    </ul>  
                    
                </transition>
            </div>
        </ul>
    </div>
</template>

<script>
    export default {
        props: ['items'],
        methods: {
            openItem(item, parent){
                parent.forEach(element => {
                   if(element === item){
                    element.isopen = !element.isopen
                   }
                   else{
                    element.isopen = false;
                   }
                })
                // item.isopen = !item.isopen   
            },
            
            setClass(item){
                if (item.isopen == true ) {
                    return 'open'

                }
                return 'close'
            },
            
            // enter: function(el, done){   
            //     Velocity(el, 'slideDown', {duration: 400,  
            //                             easing: "easeInBack"},
            //                             {complete: done})
            // },
            
            // leave: function(el, done){
            //     Velocity(el, 'slideUp', {duration: 400,  
            //                             easing: "easeInBack"},
            //                             {complete: done})
            // },
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/views/products/accordion.vue